import { Grid } from "@material-ui/core";
import {
  InputReactDatepicker,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import React from "react";
import { STATE_FILTER_DETAIL_PEMBAYARAN } from "../helpers";
import { toLastHoursDay } from "utils/dates";
import { isNull } from "App/utils/helpers";

function FormFilterDetailPembayaran({
  formFilter,
  setFormFilter,
  fetchDataBayar,
}) {
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetchDataBayar(formFilter);
  };

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3} className={"p1"}>
          <Grid item sm={12}>
            <Grid container spacing={1}>
              <Grid item sm={4}>
                <InputTextMaster
                  name="id_tagihan"
                  label="ID TAGIHAN"
                  id="id_tagihan"
                  value={formFilter.id_tagihan}
                  onChange={handleChange("id_tagihan")}
                  placeholder="ID Tagihan"
                />
              </Grid>
              <Grid item sm={4}>
                <InputTextMaster
                  name="guarantor_name"
                  label="NAMA PENANGGUNG"
                  id="guarantor_name"
                  value={formFilter.guarantor_name}
                  onChange={handleChange("guarantor_name")}
                  placeholder="Nama Penanggung"
                />
              </Grid>

              <Grid item sm={4}>
                <InputReactDatepicker
                  selected={formFilter.tanggal_awal}
                  label="TANGGAL"
                  isClearable
                  dateFormat="dd/MM/yyyy"
                  handleChangeToday={(e) =>
                    setFormFilter({
                      ...formFilter,
                      tanggal_awal: e,
                    })
                  }
                  onChange={(e) =>
                    !isNull(e) ? 
                    setFormFilter({
                      ...formFilter,
                      tanggal_awal: e,
                      tanggal_akhir: toLastHoursDay(new Date(e)),
                    }) :
                    setFormFilter({
                      ...formFilter,
                      tanggal_awal: "",
                      tanggal_akhir: "",
                    })
                  }
                  withPeriode={true}
                >
                  <button
                    type={"button"}
                    onClick={null}
                    style={{
                      borderLeft: "1px solid #EAEAEA",
                      borderTop: "1px solid #EAEAEA",
                      borderBottom: "1px solid #EAEAEA",
                      borderRight: "1px solid #EAEAEA",
                      background: "#fff",
                      padding: "0 0.8rem 0 0.8rem",
                      cursor: "pointer",
                      // borderRadius: "6px 0 0 6px",
                      fontSize: "10px",
                    }}
                  >
                    s/d
                  </button>
                  <InputReactDatepicker
                    selected={formFilter.tanggal_akhir}
                    label=""
                    isClearable
                    dateFormat="dd/MM/yyyy"
                    minDate={new Date(formFilter.tanggal_awal)}
                    handleChangeToday={(e) =>
                      setFormFilter({
                        ...formFilter,
                        tanggal_akhir: e,
                      })
                    }
                    onChange={(e) =>
                      isNull(e) ?
                      setFormFilter({
                        ...formFilter,
                        tanggal_akhir: "",
                      }) :
                      setFormFilter({
                        ...formFilter,
                        tanggal_akhir: e,
                      })
                    }
                    withParentPeriode={true}
                  />
                </InputReactDatepicker>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="mb-2"
        >
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(STATE_FILTER_DETAIL_PEMBAYARAN)}
          />

          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            type={"submit"}
            size={"md"}
          />
        </Grid>
      </form>
    </>
  );
}

export default FormFilterDetailPembayaran;
